// extracted by mini-css-extract-plugin
module.exports = {"tip":"src-pages-electronicTaxBureau-components-HubeiEleAuthWrap-HubeiCaAuth-__index__tip--2wpwH"};